/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectActivityResourcePendingActionsInner
 */
export interface ProjectActivityResourcePendingActionsInner {
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePendingActionsInner
     */
    actionType: ProjectActivityResourcePendingActionsInnerActionTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ProjectActivityResourcePendingActionsInner
     */
    dueDate: Date;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProjectActivityResourcePendingActionsInner
     */
    extraData: { [key: string]: string; };
}


/**
 * @export
 */
export const ProjectActivityResourcePendingActionsInnerActionTypeEnum = {
    AddPurchaseOrder: 'ADD_PURCHASE_ORDER',
    ApproveQuote: 'APPROVE_QUOTE',
    ApproveContract: 'APPROVE_CONTRACT',
    PreApproveContract: 'PRE_APPROVE_CONTRACT',
    ConfirmInvoicedProjectCompletion: 'CONFIRM_INVOICED_PROJECT_COMPLETION',
    ConfirmPrepaidProjectCompletion: 'CONFIRM_PREPAID_PROJECT_COMPLETION',
    ConfirmPrematureProjectCompletion: 'CONFIRM_PREMATURE_PROJECT_COMPLETION',
    LeaveAppraisal: 'LEAVE_APPRAISAL',
    PaymentOverdue: 'PAYMENT_OVERDUE',
    LotPaymentOverdue: 'LOT_PAYMENT_OVERDUE',
    LotPrePaymentOverdue: 'LOT_PRE_PAYMENT_OVERDUE',
    PayProject: 'PAY_PROJECT',
    PayProjectLot: 'PAY_PROJECT_LOT',
    PrePayProjectLot: 'PRE_PAY_PROJECT_LOT',
    BalanceProjectLot: 'BALANCE_PROJECT_LOT',
    PayProjectExpense: 'PAY_PROJECT_EXPENSE',
    ExpensePaymentOverdue: 'EXPENSE_PAYMENT_OVERDUE',
    PrepayProject: 'PREPAY_PROJECT',
    ReviewActivityReport: 'REVIEW_ACTIVITY_REPORT',
    ReviewExpenseReport: 'REVIEW_EXPENSE_REPORT',
    ReviewExpenseBatch: 'REVIEW_EXPENSE_BATCH',
    PaidExpenseReport: 'PAID_EXPENSE_REPORT',
    RenewProject: 'RENEW_PROJECT',
    ConfirmMisclassificationGuideline: 'CONFIRM_MISCLASSIFICATION_GUIDELINE',
    TermsReviewRequested: 'TERMS_REVIEW_REQUESTED'
} as const;
export type ProjectActivityResourcePendingActionsInnerActionTypeEnum = typeof ProjectActivityResourcePendingActionsInnerActionTypeEnum[keyof typeof ProjectActivityResourcePendingActionsInnerActionTypeEnum];


/**
 * Check if a given object implements the ProjectActivityResourcePendingActionsInner interface.
 */
export function instanceOfProjectActivityResourcePendingActionsInner(value: object): value is ProjectActivityResourcePendingActionsInner {
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('extraData' in value) || value['extraData'] === undefined) return false;
    return true;
}

export function ProjectActivityResourcePendingActionsInnerFromJSON(json: any): ProjectActivityResourcePendingActionsInner {
    return ProjectActivityResourcePendingActionsInnerFromJSONTyped(json, false);
}

export function ProjectActivityResourcePendingActionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectActivityResourcePendingActionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'actionType': json['actionType'],
        'dueDate': (new Date(json['dueDate'])),
        'extraData': json['extraData'],
    };
}

export function ProjectActivityResourcePendingActionsInnerToJSON(value?: ProjectActivityResourcePendingActionsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'actionType': value['actionType'],
        'dueDate': ((value['dueDate']).toISOString()),
        'extraData': value['extraData'],
    };
}

